<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onMounted, onUnmounted, ref } from 'vue';

import useCartWidget from '@/composables/useCartWidget';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore';

import CartDesktop from './CartDesktop.vue';
import CartMobile from './CartMobile.vue';

const globalConfigurationStore = useGlobalConfigurationStore();
const { globalConfiguration } = storeToRefs(globalConfigurationStore);
const { loadProductsFromLocalStorage, handleCartEvent } = useCartWidget();

const mobileBreakpoint = 768;

const windowWidth = ref(window.innerWidth);
const isMobile = ref(window.innerWidth < mobileBreakpoint);

function handleResize() {
  windowWidth.value = window.innerWidth;
  isMobile.value = window.innerWidth < mobileBreakpoint;
}

onMounted(() => {
  if (!globalConfiguration.value || !globalConfiguration.value.apikey) {
    throw new Error('api-key to setup cart components is missing');
  }
  loadProductsFromLocalStorage();
  window.addEventListener('message', handleCartEvent);
  window.addEventListener('resize', handleResize);
  handleResize();
});

onUnmounted(() => {
  window.removeEventListener('message', handleCartEvent);
  window.removeEventListener('resize', handleResize);
});
</script>

<template>
  <CartDesktop v-if="!isMobile" :api-key="globalConfiguration!.apikey" />
  <!-- <CartMobile v-else :api-key="globalConfiguration!.apikey" /> -->
  <CartMobile v-else />
</template>

<style scoped>

</style>
